import axios from 'axios'
import API from './index'
export default {
  get(start, end) {
    // const proxyurl = 'https://cors-anywhere.herokuapp.com/'

    const url = API.BASE_URL + 'CalendarEvents?start=' + start + "&end=" + end 
    return axios
      .get(url, {})
      .then(response => {
        return response.data
      })
  },

  getEvent(eventId) {
    const url = API.BASE_URL + 'CalendarEvents/' + eventId
    return axios
      .get(url, {
      })
      .then(response => {
        return response.data
      })
  },

  create(evt) {
    const url = API.BASE_URL + 'CalendarEvents'
    return axios
      .post(url, {
        calendarEventId: evt.calendarEventId,
        title: evt.title,
        description: evt.description,
        startDate: evt.startDate,
        endDate: evt.endDate,
        isAllDay: evt.isAllDay,
        eventColorId: evt.eventColorId,
        url: evt.url,
      })
      .then(response => {
        return response.data
      })
  },

  update(evt) {
    const url = API.BASE_URL + 'CalendarEvents/' + evt.calendarEventId
    return axios
      .put(url, {
        calendarEventId: evt.calendarEventId,
        title: evt.title,
        description: evt.description,
        startDate: evt.startDate,
        endDate: evt.endDate,
        isAllDay: evt.isAllDay,
        eventColorId: evt.eventColorId,
        url: evt.url,
      })
      .then(response => {
        return response.data
      })
  },

  delete(id) {
    const url = API.BASE_URL + 'CalendarEvents/' + id
    return axios
      .delete(url, {})
      .then(response => {
        return response.data
      })
  },

}
